import { render, staticRenderFns } from "./PropertyPatent.vue?vue&type=template&id=ff2f292c&scoped=true"
import script from "./PropertyPatent.vue?vue&type=script&lang=js"
export * from "./PropertyPatent.vue?vue&type=script&lang=js"
import style0 from "./PropertyPatent.vue?vue&type=style&index=0&id=ff2f292c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2f292c",
  null
  
)

export default component.exports